module.exports = __webpack_public_path__ + "static/media/ajustes.b1ea97fc.svg";